var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g3, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 383,
    viewBox: "0 0 611 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8822 117.322H541.753",
    stroke: "#DED8D5",
    strokeWidth: 4.24694,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M535.552 380H73.0842C69.6589 380 66.8822 377.223 66.8822 373.799V92.3935C66.8822 88.9691 69.6589 86.1933 73.0842 86.1933H535.552C538.977 86.1933 541.753 88.9691 541.753 92.3935V373.799C541.753 377.223 538.977 380 535.552 380Z",
    stroke: "#DED8D5",
    strokeWidth: 4.24694,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.993 102.075C98.993 104.923 96.6838 107.233 93.8348 107.233C90.9858 107.233 88.6765 104.923 88.6765 102.075C88.6765 99.2261 90.9858 96.9168 93.8348 96.9168C96.6838 96.9168 98.993 99.2261 98.993 102.075Z",
    fill: "#FFB0A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.681 102.075C115.681 104.816 113.458 107.04 110.716 107.04C107.974 107.04 105.751 104.816 105.751 102.075C105.751 99.3328 107.974 97.11 110.716 97.11C113.458 97.11 115.681 99.3328 115.681 102.075Z",
    fill: "#E9D153"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.308 102.075C132.308 104.676 130.199 106.785 127.598 106.785C124.996 106.785 122.888 104.676 122.888 102.075C122.888 99.4735 124.996 97.3647 127.598 97.3647C130.199 97.3647 132.308 99.4735 132.308 102.075Z",
    fill: "#1D69B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M518.82 192.356H576.826C579.988 192.356 582.553 189.793 582.553 186.631V139.091C582.553 135.93 579.988 133.366 576.826 133.366H518.82C515.658 133.366 513.094 135.93 513.094 139.091V186.631C513.094 189.793 515.658 192.356 518.82 192.356Z",
    fill: "#03458F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M563.667 172.669H536.516H531.613V151.174H563.667V156.548V172.669Z",
    stroke: "white",
    strokeWidth: 3.55423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M531.614 151.174L547.593 162.853L563.667 151.174",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M531.615 151.174L547.64 136.435L563.667 151.174",
    stroke: "white",
    strokeWidth: 3.55423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4183 288.629H31.2171C27.73 288.629 24.9038 285.802 24.9038 282.315V229.005C24.9038 225.518 27.73 222.692 31.2171 222.692H86.4183C89.9054 222.692 92.7326 225.518 92.7326 229.005V282.315C92.7326 285.802 89.9054 288.629 86.4183 288.629Z",
    fill: "#95B5FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4586 256.275C77.4586 266.342 69.2986 274.503 59.2319 274.503C49.1653 274.503 41.0052 266.342 41.0052 256.275C41.0052 246.209 49.1653 238.049 59.2319 238.049C69.2986 238.049 77.4586 246.209 77.4586 256.275Z",
    stroke: "white",
    strokeWidth: 4.316,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8419 246.616H74.6914",
    stroke: "white",
    strokeWidth: 5.1792,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0052 256.276H77.2761",
    stroke: "white",
    strokeWidth: 5.1792,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7744 265.936H74.6876",
    stroke: "white",
    strokeWidth: 5.1792,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_8322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 238,
    width: 37,
    height: 37
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4548 256.279C77.4548 266.34 69.2958 274.499 59.2348 274.499C49.1643 274.499 41.0052 266.34 41.0052 256.279C41.0052 246.208 49.1643 238.049 59.2348 238.049C69.2958 238.049 77.4548 246.208 77.4548 256.279Z",
    fill: "#FF0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_8322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6307 238.32C67.7314 246.616 64.4592 259.964 73.1698 274.503",
    stroke: "white",
    strokeWidth: 4.316,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6307 238.32C67.7314 246.616 64.4592 259.964 73.1698 274.503",
    stroke: "white",
    strokeWidth: 4.316,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1025 238.32C39.2032 246.616 35.931 259.964 44.6416 274.503",
    stroke: "white",
    strokeWidth: 4.316,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22_8322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 238,
    width: 37,
    height: 37
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4548 256.279C77.4548 266.34 69.2958 274.499 59.2348 274.499C49.1643 274.499 41.0052 266.34 41.0052 256.279C41.0052 246.208 49.1643 238.049 59.2348 238.049C69.2958 238.049 77.4548 246.208 77.4548 256.279Z",
    fill: "#FF0000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22_8322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0884 238.496C84.4793 247.77 86.2613 261.441 78.5901 274.109",
    stroke: "white",
    strokeWidth: 4.29469,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0884 238.496C84.4793 247.77 86.2613 261.441 78.5901 274.109",
    stroke: "white",
    strokeWidth: 4.29469,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5602 238.496C55.9511 247.77 57.7331 261.441 50.0619 274.109",
    stroke: "white",
    strokeWidth: 4.29469,
    strokeMiterlimit: 10
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M607.373 294.613H560.572C558.58 294.613 556.964 292.998 556.964 291.006C556.964 289.014 558.58 287.399 560.572 287.399H607.373C609.365 287.399 610.979 289.014 610.979 291.006C610.979 292.998 609.365 294.613 607.373 294.613Z",
    fill: "#4A8FE2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M574.595 336.339H568.876C567.373 336.339 566.155 335.119 566.155 333.617V328.248C566.155 326.745 567.373 325.528 568.876 325.528H574.595C576.097 325.528 577.316 326.745 577.316 328.248V333.617C577.316 335.119 576.097 336.339 574.595 336.339Z",
    fill: "#03458F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5124 361.327H26.7934C25.2909 361.327 24.0728 360.109 24.0728 358.607V353.238C24.0728 351.735 25.2909 350.517 26.7934 350.517H32.5124C34.0148 350.517 35.233 351.735 35.233 353.238V358.607C35.233 360.109 34.0148 361.327 32.5124 361.327Z",
    fill: "#95B5FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M470.207 55.3534H375.034C373.452 55.3534 372.169 54.0706 372.169 52.4892V29.252C372.169 27.6705 373.452 26.3896 375.034 26.3896H470.207C471.789 26.3896 473.071 27.6705 473.071 29.252V52.4892C473.071 54.0706 471.789 55.3534 470.207 55.3534Z",
    fill: "#95B5FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M385.913 36.7102H453.599",
    stroke: "white",
    strokeWidth: 2.54644,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M385.913 43.6568H413.481",
    stroke: "white",
    strokeWidth: 2.54644,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M383.16 52.0774V63.367L397.357 52.0774H383.16Z",
    fill: "#95B5FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M236.377 57.0775H190.305C185.83 57.0775 182.203 53.4496 182.203 48.9745V6.14219C182.203 2.75018 184.953 6.10352e-05 188.345 6.10352e-05H236.377C239.769 6.10352e-05 242.519 2.75018 242.519 6.14219V50.9344C242.519 54.3273 239.769 57.0775 236.377 57.0775Z",
    fill: "#4A8FE2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M226.437 32.76L223.003 29.3261C222.39 28.6509 221.593 28.2829 220.796 28.2829C219.998 28.2829 219.201 28.65 218.588 29.2633L216.624 31.227L216.256 31.0426C216.012 30.9199 215.828 30.859 215.644 30.7363C213.804 29.5705 212.148 28.0376 210.553 26.0748C209.817 25.1553 209.266 24.2966 208.96 23.5605C209.449 23.1317 209.879 22.64 210.308 22.2112C210.492 22.0276 210.676 21.8431 210.86 21.6596C211.535 20.9844 211.903 20.1876 211.903 19.3897C211.903 18.5928 211.535 17.7959 210.86 17.1208L209.143 15.4034C208.96 15.2198 208.775 15.0344 208.591 14.79C208.224 14.421 207.794 13.9931 207.426 13.6251C206.812 13.0118 206.015 12.6437 205.218 12.6437C204.421 12.6437 203.684 12.9499 203.009 13.6251L200.863 15.7714C200.066 16.5692 199.576 17.6115 199.453 18.7764C199.33 20.6164 199.821 22.3338 200.25 23.4379C201.231 26.2593 202.763 28.7736 205.033 31.4724C207.793 34.7227 211.043 37.2988 214.846 39.1389C216.256 39.8131 218.22 40.609 220.367 40.7935H220.796C222.268 40.7935 223.494 40.2429 224.474 39.1997L224.536 39.1389C224.843 38.7709 225.211 38.4028 225.641 38.0348C225.886 37.7895 226.192 37.4823 226.437 37.237C227.725 35.8886 227.725 34.0475 226.437 32.76ZM225.028 35.9485C224.782 36.1938 224.536 36.4401 224.291 36.6854C223.861 37.0535 223.494 37.4823 223.064 37.9112C222.451 38.5246 221.776 38.8317 220.856 38.8317H220.551C218.71 38.709 216.993 37.9721 215.766 37.3587C212.271 35.6413 209.203 33.2506 206.628 30.1848C204.542 27.6696 203.133 25.277 202.151 22.7627C201.538 21.2906 201.292 20.1257 201.415 18.9608C201.476 18.2866 201.722 17.6733 202.274 17.1826L204.36 15.0972C204.543 14.9127 204.85 14.6673 205.218 14.6673C205.586 14.6673 205.83 14.8518 206.075 15.0972C206.443 15.4652 206.812 15.8322 207.18 16.2003C207.365 16.3838 207.547 16.6301 207.793 16.8136L209.51 18.532C209.694 18.7155 209.939 19.0835 209.939 19.3897C209.939 19.7577 209.694 20.0649 209.51 20.2484L208.96 20.8009C208.407 21.3525 207.916 21.8431 207.426 22.3338L207.365 22.3956C206.751 23.009 206.873 23.5605 206.996 23.9286V23.9894C207.425 25.0935 208.101 26.0748 209.02 27.3015C210.738 29.4488 212.577 31.1034 214.601 32.391C214.846 32.5755 215.153 32.6991 215.399 32.8208C215.644 32.9444 215.828 33.0053 216.013 33.128L216.073 33.1898C216.686 33.496 217.299 33.3733 217.79 32.8826L219.936 30.7363C220.12 30.5519 220.428 30.3065 220.796 30.3065C221.102 30.3065 221.408 30.5519 221.592 30.7363L225.028 34.1702C225.58 34.7227 225.58 35.3351 225.028 35.9485Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_22_8322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 4,
    width: 486,
    height: 375
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M548.081 4.05011V378.721H63.1012V4.05011H548.081Z",
    fill: "#4A8FE2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_22_8322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.106 273.15L202.429 269.198L202.7 265.751L167.989 270.373C167.989 270.373 149.045 321.142 165.905 426.692H190.045L198.461 319.666H201.547L210.235 426.692H234.376C251.237 321.142 232.106 273.15 232.106 273.15Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74 128.754C225.723 124.029 222.507 118.516 219.774 110.78C216.839 102.476 207.232 105.851 207.232 105.851C207.232 105.851 199.226 95.5517 187.178 99.1396C175.131 102.727 170.945 111.3 170.699 121.492C170.453 131.685 162.437 133.278 156.263 145.07C145.364 165.885 163.714 183.419 197.115 178.555L197.159 178.23C200.449 179.23 204.48 179.665 209.401 179.373C249.527 176.991 245.654 147.477 229.74 128.754Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.602 144.19C219.9 147.181 227.275 135.835 224.088 132.649C220.901 129.464 218.47 134.461 218.47 134.461L217.047 137.849L215.975 142.436L215.719 143.637L216.602 144.19Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.549 136.669C222.549 136.669 220.052 135.546 217.834 139.166",
    stroke: "#282828",
    strokeWidth: 2.14289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.602 143.846C174.569 147.106 166.26 136.424 169.166 132.981C172.072 129.537 174.917 134.312 174.917 134.312L176.622 137.566L178.079 142.046L178.434 143.221L177.602 143.846Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.041 136.855C171.041 136.855 173.433 135.525 175.95 138.944",
    stroke: "#282828",
    strokeWidth: 2.14289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.387 121.826C222.387 136.845 210.936 143.968 196.81 143.968C182.685 143.968 171.234 136.845 171.234 121.826C171.234 106.807 182.685 96.5901 196.81 96.5901C210.936 96.5901 222.387 106.807 222.387 121.826Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.232 182.588H186.191V155.341H207.232V182.588Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.12 153.642C183.12 153.642 188.977 165.331 196.183 167.156C198.107 167.644 200.163 167.476 202.019 166.818C204.732 165.857 208.17 161.813 208.755 157.34L209.026 154.784C209.026 154.784 196.204 161.765 183.12 153.642Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.911 122.871C218.911 132.092 217.607 140.048 216.307 145.695C215.034 151.224 211.451 155.087 206.388 158.197L205.467 158.764C200.11 162.055 193.188 162.131 187.749 158.96C182.264 155.762 178.422 151.545 177.24 145.613C175.09 134.822 174.856 122.871 174.856 122.871C174.856 122.871 172.81 99.5951 196.569 100.048C220.327 100.499 218.911 122.871 218.911 122.871Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.223 137.415V139.328C195.223 139.518 195.26 139.701 195.327 139.868C195.591 140.525 196.351 140.838 197.038 140.657L198.515 140.267",
    stroke: "#282828",
    strokeWidth: 2.65434,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.174 124.798L212.814 127.791C212.814 127.791 212.239 124.541 207.068 123.36C201.897 122.18 200.174 124.798 200.174 124.798Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.537 124.798L180.734 127.791C180.734 127.791 181.315 124.541 186.552 123.36C191.79 122.18 193.537 124.798 193.537 124.798Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.636 143.968H205.112C205.112 143.968 203.879 148.77 195.954 148.77C189.918 148.77 187.636 143.968 187.636 143.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.16 130.588C175.16 130.588 184.659 117.746 182.468 104.736C182.468 104.736 175.418 108.285 173.582 117.442C171.745 126.6 175.16 130.588 175.16 130.588Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.926 130.161C218.926 130.161 207.892 116.874 210.083 103.864C210.083 103.864 217.737 108.286 219.573 117.442C221.408 126.601 218.926 130.161 218.926 130.161Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.958 109.86C175.958 109.86 186.857 124.511 220.228 122.226C220.228 122.226 216.417 101.333 200.244 99.2461C200.244 99.2461 181.571 97.0171 175.958 109.86Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.537 337.593C145.052 338.357 173.313 214.631 164.922 216.502C164.158 216.672 149.462 218.037 147.279 222.478C140.947 235.35 136.406 336.654 136.406 336.654L145.537 337.593Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.407 336.654C136.407 336.654 131.852 357.79 149.071 360.1C150.206 360.252 151.302 359.582 151.676 358.5L151.725 358.357C152.137 357.162 151.539 355.882 150.385 355.367C147.578 354.111 143.223 350.939 145.384 343.737C145.384 343.737 147.873 343.432 149.246 348.075C149.6 349.27 150.941 349.869 152.053 349.309C152.812 348.926 153.24 348.11 153.133 347.266C152.72 344.014 151.084 336.186 144.807 334.086L136.407 336.654Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.202 252.206C142.202 252.206 158.485 275.137 158.57 274.693C158.656 274.251 165.69 233.346 165.69 233.346L145.099 231.206L142.202 252.206Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.444 178.101C188.138 178.097 147.202 178.83 139.72 230.521L163.246 234.125L167.989 273.149H233.62L246.649 201.048C246.649 201.048 237.387 185.427 210.388 177.775L187.444 178.101Z",
    fill: "#1D69B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.435 184.35C167.435 184.35 173.218 192.029 196.922 192.029C220.407 192.029 226.412 183.947 226.412 183.947C226.412 183.947 212.568 176.212 196.504 173.711C196.504 173.711 182.16 176.266 167.435 184.35Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.854 132.952C188.854 134.049 187.962 134.938 186.862 134.938C185.762 134.938 184.871 134.049 184.871 132.952C184.871 131.856 185.762 130.967 186.862 130.967C187.962 130.967 188.854 131.856 188.854 132.952Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.053 132.952C189.053 134.158 188.072 135.136 186.861 135.136C185.652 135.136 184.672 134.158 184.672 132.952C184.672 131.746 185.652 130.768 186.861 130.768C188.072 130.768 189.053 131.746 189.053 132.952Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.732 132.952C207.732 134.049 206.841 134.938 205.741 134.938C204.64 134.938 203.749 134.049 203.749 132.952C203.749 131.856 204.64 130.967 205.741 130.967C206.841 130.967 207.732 131.856 207.732 132.952Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.931 132.952C207.931 134.158 206.951 135.136 205.74 135.136C204.53 135.136 203.55 134.158 203.55 132.952C203.55 131.746 204.53 130.768 205.74 130.768C206.951 130.768 207.931 131.746 207.931 132.952Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.056 222.555C454.087 217.815 437.405 217.982 436.525 217.879C432.015 217.35 439.416 253.237 448.797 284.605C450.595 290.618 457.212 293.751 462.991 291.3C463.054 291.274 463.116 291.247 463.179 291.221C467.751 289.284 470.352 284.431 469.432 279.552C464.97 255.882 460.49 228.036 457.056 222.555Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.032 235.531L439.735 243.796L437.738 233.69L459.791 228.189L461.032 235.531Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.243 260.147C466.243 260.147 454.965 269.299 455.446 268.676C455.927 268.052 463.358 246.777 463.358 246.777L466.243 260.147Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.19 236.514L450.201 275.4C446.657 280.505 448.229 287.548 453.607 290.664C458.974 293.774 465.854 291.648 468.53 286.051L490.327 240.476L477.19 236.514Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.152 245.745C478.788 244.039 475.011 237.499 476.717 231.135C478.422 224.77 484.965 220.995 491.329 222.7C497.693 224.406 501.469 230.947 499.763 237.311C498.057 243.676 491.516 247.451 485.152 245.745Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.36 202.668L513.718 207.299C514.405 207.556 514.692 208.342 514.356 209.052L499.952 239.576C499.616 240.286 498.786 240.655 498.099 240.396L485.74 235.766C485.052 235.508 484.767 234.723 485.103 234.012L499.508 203.489C499.843 202.778 500.673 202.41 501.36 202.668Z",
    fill: "#372E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.178 202.2L512.537 206.832C513.225 207.09 513.51 207.875 513.175 208.585L498.77 239.109C498.433 239.82 497.605 240.186 496.916 239.929L484.558 235.298C483.87 235.04 483.585 234.255 483.921 233.544L498.326 203.021C498.66 202.31 499.49 201.943 500.178 202.2Z",
    fill: "#251B42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.967 205.292L509.825 209.361L498.086 234.239L487.227 230.169L498.967 205.292Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.826 209.361L487.226 230.169L498.967 205.292L509.826 209.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.75 220.991C487.846 218.911 480.722 219.818 476.718 231.135L481.235 234.732C484.768 234.025 487.426 229.899 488.227 228.517L496.565 226.62C496.565 226.62 499.654 223.07 493.75 220.991Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.785 273.185L402.074 268.564L402.345 272.011L372.667 275.962C372.667 275.962 353.538 323.955 370.397 429.505H394.538L403.227 322.478H406.313L414.729 429.505H438.869C455.73 323.955 436.785 273.185 436.785 273.185Z",
    fill: "#8E706B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.19 322.478H417.377",
    stroke: "#282828",
    strokeWidth: 2.66081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.93 175.37C412.236 175.366 457.573 181.643 465.054 233.335L441.527 236.94L436.785 275.962H371.154L358.124 203.863C358.124 203.863 372.665 183.023 399.663 175.37H412.93Z",
    fill: "#78A3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.528 236.94L443.569 214.37",
    stroke: "#282828",
    strokeWidth: 2.66081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.24 176.109V158.155H396.2V176.32C395.123 176.641 393.33 177.291 390.547 178.613L406.957 188.387L423.733 178.613C423.733 178.613 421.071 177.063 417.24 176.109Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.005 160.348C396.005 160.348 399.783 170.381 409.87 169.515C419.142 168.719 417.666 154.814 417.666 154.814L396.005 160.348Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.828 147.003C383.53 149.995 376.155 138.648 379.343 135.463C382.529 132.278 384.96 137.275 384.96 137.275L386.382 140.662L387.455 145.25L387.711 146.451L386.828 147.003Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.883 139.482C380.883 139.482 383.378 138.359 385.596 141.979",
    stroke: "#282828",
    strokeWidth: 2.14289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.829 146.66C428.863 149.92 437.17 139.238 434.264 135.794C431.358 132.35 428.514 137.125 428.514 137.125L426.81 140.379L425.352 144.859L424.996 146.034L425.829 146.66Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.39 139.668C432.39 139.668 429.997 138.338 427.481 141.756",
    stroke: "#282828",
    strokeWidth: 2.14289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.044 124.64C381.044 139.659 392.495 146.782 406.62 146.782C420.746 146.782 432.197 139.659 432.197 124.64C432.197 109.621 420.746 99.4039 406.62 99.4039C392.495 99.4039 381.044 109.621 381.044 124.64Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52 125.684C384.52 134.904 385.823 142.861 387.123 148.508C388.396 154.036 391.98 157.901 397.042 161.012L397.964 161.578C403.32 164.869 410.243 164.946 415.683 161.774C421.168 158.576 425.009 154.359 426.191 148.426C428.341 137.636 428.575 125.684 428.575 125.684C428.575 125.684 430.621 102.409 406.863 102.861C383.103 103.314 384.52 125.684 384.52 125.684Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.107 138.968V142.189C405.107 142.379 405.142 142.562 405.209 142.73C405.474 143.388 406.233 143.704 406.92 143.521L408.397 143.129",
    stroke: "#282828",
    strokeWidth: 2.65866,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.329 126.478L389.521 129.246C389.521 129.246 390.058 126.241 394.889 125.15C399.719 124.057 401.329 126.478 401.329 126.478Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.809 126.478L423.208 129.246C423.208 129.246 422.69 126.241 418.026 125.15C413.362 124.057 411.809 126.478 411.809 126.478Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.833 147.27H414.189C414.189 147.27 407.383 155.549 398.833 147.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.472 135.924C404.472 140.601 400.682 144.392 396.005 144.392C391.328 144.392 387.536 140.601 387.536 135.924C387.536 131.247 391.328 127.456 396.005 127.456C400.682 127.456 404.472 131.247 404.472 135.924Z",
    stroke: "#03458F",
    strokeWidth: 2.89604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.275 135.924C425.275 140.601 421.484 144.392 416.808 144.392C412.131 144.392 408.339 140.601 408.339 135.924C408.339 131.247 412.131 127.456 416.808 127.456C421.484 127.456 425.275 131.247 425.275 135.924Z",
    stroke: "#03458F",
    strokeWidth: 2.89604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.472 135.923C404.472 135.923 406.478 134.051 408.339 135.923",
    stroke: "#03458F",
    strokeWidth: 2.89604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.537 135.923L384.869 135.856",
    stroke: "#03458F",
    strokeWidth: 2.89604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.275 135.923L427.958 135.856",
    stroke: "#03458F",
    strokeWidth: 2.89604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.271 133.401C428.271 133.401 418.771 120.56 420.962 107.551C420.962 107.551 428.012 111.099 429.848 120.256C431.685 129.415 428.271 133.401 428.271 133.401Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.504 134.271C384.504 134.271 395.539 119.687 393.348 106.677C393.348 106.677 385.694 111.099 383.858 120.256C382.022 129.415 384.504 134.271 384.504 134.271Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.473 112.673C427.473 112.673 415.276 126.026 381.904 123.74C381.904 123.74 387.014 104.146 403.187 102.059C403.187 102.059 421.861 99.829 427.473 112.673Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.551 97.0636C442.551 105.864 435.417 112.998 426.617 112.998C417.817 112.998 410.683 105.864 410.683 97.0636C410.683 88.2636 417.817 81.1316 426.617 81.1316C435.417 81.1316 442.551 88.2636 442.551 97.0636Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.833 135.152C398.833 136.248 397.941 137.137 396.841 137.137C395.742 137.137 394.851 136.248 394.851 135.152C394.851 134.055 395.742 133.166 396.841 133.166C397.941 133.166 398.833 134.055 398.833 135.152Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.032 135.152C399.032 136.358 398.051 137.336 396.841 137.336C395.632 137.336 394.651 136.358 394.651 135.152C394.651 133.946 395.632 132.968 396.841 132.968C398.051 132.968 399.032 133.946 399.032 135.152Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.711 135.152C417.711 136.248 416.82 137.137 415.72 137.137C414.62 137.137 413.729 136.248 413.729 135.152C413.729 134.055 414.62 133.166 415.72 133.166C416.82 133.166 417.711 134.055 417.711 135.152Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.91 135.152C417.91 136.358 416.93 137.336 415.72 137.336C414.51 137.336 413.53 136.358 413.53 135.152C413.53 133.946 414.51 132.968 415.72 132.968C416.93 132.968 417.91 133.946 417.91 135.152Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.454 285.4C360.454 285.4 379.303 283.675 392.19 275.173L391.85 267.692L360.442 271.97L360.454 285.4Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.351 201.733L198.169 260.07C198.169 260.07 220.164 290.88 201.56 303.314C186.494 310.223 179.314 296.215 179.314 296.215C179.314 296.215 152.318 244.851 142.308 206.676C142.308 206.676 142.221 201.454 150.647 199.237C159.141 197.002 161.351 201.733 161.351 201.733Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.143 210.741C163.346 216.415 158.099 220.369 152.425 219.572C146.75 218.775 142.796 213.527 143.594 207.853C144.391 202.179 149.638 198.225 155.312 199.023C160.987 199.82 164.941 205.067 164.143 210.741Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.904 206.355C161.904 206.355 159.999 212.931 152.123 212.089C144.943 211.324 142.793 206.372 141.587 204.209C137.238 196.415 139.598 175.289 139.598 175.289C139.598 175.289 170.872 176.058 170.456 176.354C170.038 176.651 161.904 206.355 161.904 206.355Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.904 206.354C162.24 204.789 174.262 191.319 178.59 186.194C179.634 184.958 179.284 182.998 177.858 182.074C176.929 181.473 175.284 180.951 173.944 182.089L162.426 190.961L161.904 206.354Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.312 189.122L173.063 163.986C173.412 162.326 172.29 160.631 170.621 160.295C169.177 160.005 167.806 160.842 167.419 162.252L162.44 180.383L168.312 189.122Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 176.781L162.881 157.612C162.945 155.947 161.636 154.478 159.996 154.377C158.573 154.288 157.359 155.265 157.131 156.681L154.064 177.768L162.497 176.781Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.695 178.912L152.279 159.352C152.156 157.539 150.608 156.093 148.839 156.137C147.176 156.179 145.902 157.526 145.917 159.227L146.074 177.217L153.695 178.912Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.598 175.289L137.35 162.746C137.304 161.359 138.32 160.236 139.673 160.178C140.967 160.122 142.157 161.06 142.449 162.369L146.073 177.217L139.598 175.289Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.312 187.319C162.312 187.319 152.148 185.893 150.626 199.449",
    stroke: "#282828",
    strokeWidth: 3.30606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1 269.108C175.117 278.52 172.426 290.942 181.733 300.035C185.079 303.303 190.355 306.094 195.421 305.201C212.307 302.223 240.073 268.279 240.073 268.279L237.441 207.127L189.224 262.847L184.1 269.108Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.053 245.167C203.053 245.167 217.614 269.843 230.661 278.96L240.071 268.279L207.396 240.15L203.053 245.167Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23 176.426C272.23 176.426 225.658 186.497 200.417 240.3C200.417 240.3 215.186 262.98 239.091 273.212L255.325 253.674L272.23 176.426Z",
    fill: "#03458F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.978 348.104L248.028 441.898H299.386L302.952 348.104H247.978Z",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.733 348.104L307.299 441.898H358.656L358.707 348.104H303.733Z",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.853 383.918H278.124V348.104H330.853V383.918Z",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.924 258.142C394.086 293.074 390.75 318.525 391.673 382.802L361.235 384.077L356.699 263.762L390.924 258.142Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.215 177.716C330.215 177.716 390.085 192.772 400.933 268.766C400.933 268.766 371.63 281.469 342.265 276.005L348.872 250.588L330.215 177.716Z",
    fill: "#03458F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.207 176.231C254.049 185.545 242.633 197.897 242.633 197.897L246.216 355.809H360.641L360.27 198.711C360.27 198.711 345.847 184.597 330.214 177.716C316.938 171.871 285.115 169.611 272.207 176.231Z",
    fill: "#03458F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.907 244.975C334.106 244.975 330.214 241.084 330.214 236.283V227.01H347.599V236.283C347.599 241.084 343.707 244.975 338.907 244.975Z",
    stroke: "#282828",
    strokeWidth: 2.158,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.454 276.592L361.937 224.935",
    stroke: "#282828",
    strokeWidth: 3.01473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.393 267.982L241.92 223.204",
    stroke: "#282828",
    strokeWidth: 3.01473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.548 118.553L268.777 94.9564C268.509 93.0346 267.763 90.0686 268.676 87.2814C270.187 82.6702 275.739 73.8151 285.23 77.8689L287.281 87.2119C287.281 87.2119 277.426 89.2013 273.473 102.094L273.548 118.553Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.531 82.7397C284.358 85.8407 281.621 99.4068 272 104.349C272 104.349 263.572 86.2762 284.531 82.7397Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.283 171.886V131.817H281.344V171.886L270.349 176.898C270.349 176.898 272.928 193.505 300.201 193.874C327.475 194.242 330.214 177.716 330.214 177.716L318.283 171.886Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23 77.869C285.23 77.869 292.009 59.9856 312.914 69.4931C325.566 75.2472 329.11 82.9622 330.617 88.4292C331.118 90.2455 331.318 93.1059 331.182 94.8052L326.125 118.554L306.384 85.6962L287.281 87.212L285.23 77.869Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.125 118.554C326.125 118.554 328.616 114.592 333.753 116.541C338.889 118.489 336.566 130.963 328.86 132.553C328.86 132.553 326.098 133.155 323.932 131.264C323.932 131.264 325.827 122.051 326.125 118.554Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.733 120.941C332.733 120.941 328.431 119.505 325.377 125.841",
    stroke: "#282828",
    strokeWidth: 3.01473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.548 118.554C273.548 118.554 271.056 114.592 265.92 116.541C260.784 118.489 263.108 130.963 270.813 132.553C270.813 132.553 273.574 133.155 275.74 131.264C275.74 131.264 273.845 122.051 273.548 118.554Z",
    fill: "#F2978E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.938 120.941C266.938 120.941 271.241 119.505 274.295 125.841",
    stroke: "#282828",
    strokeWidth: 3.01473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.64 106.717C326.642 114.237 325.905 129.97 321.281 139.307C316.941 148.075 309.761 152.794 300.35 153.075C290.937 153.356 283.926 149.728 278.307 138.35C272.688 126.971 272.956 106.856 272.956 106.856C272.956 106.856 272.956 79.9924 299.506 79.9924C327.47 79.9924 326.64 106.717 326.64 106.717Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.622 143.957C281.622 143.957 284.715 159.652 298.375 161.456C314.095 163.531 318.283 144.355 318.283 144.355C318.283 144.355 311.336 153.06 300.35 153.073C288.098 153.089 281.622 143.957 281.622 143.957Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.904 117.869V124.088C297.904 124.355 297.955 124.61 298.049 124.844C298.417 125.766 299.478 126.207 300.436 125.952L302.497 125.404",
    stroke: "#282828",
    strokeWidth: 3.01473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.121 102.875L320.371 107.074C320.371 107.074 319.632 102.515 312.984 100.859C306.336 99.2033 304.121 102.875 304.121 102.875Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.023 102.875L277.772 107.074C277.772 107.074 278.51 102.515 285.159 100.859C291.807 99.2033 294.023 102.875 294.023 102.875Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.791 130.35C290.791 130.35 293.188 132.188 299.492 132.188C305.225 132.188 308.806 130.35 308.806 130.35",
    stroke: "#282828",
    strokeWidth: 3.01473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.267 115.606C297.267 121.278 292.668 125.876 286.996 125.876C281.323 125.876 276.725 121.278 276.725 115.606C276.725 109.934 281.323 105.336 286.996 105.336C292.668 105.336 297.267 109.934 297.267 115.606Z",
    stroke: "white",
    strokeWidth: 4.21026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.497 115.606C322.497 121.278 317.898 125.876 312.226 125.876C306.554 125.876 301.955 121.278 301.955 115.606C301.955 109.934 306.554 105.336 312.226 105.336C317.898 105.336 322.497 109.934 322.497 115.606Z",
    stroke: "white",
    strokeWidth: 4.21026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.267 115.606C297.267 115.606 299.699 113.336 301.957 115.606",
    stroke: "white",
    strokeWidth: 4.21026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.727 115.606L273.282 115.519",
    stroke: "white",
    strokeWidth: 4.21026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.497 115.606L326.341 115.545",
    stroke: "white",
    strokeWidth: 4.21026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.621 83.353C281.621 83.353 286.554 97.3661 308.809 96.9363C323.932 96.6443 327.546 107.587 327.546 107.587C327.546 107.587 324.914 83.1219 324.222 83.353C323.53 83.5841 301.21 77.3982 301.21 77.3982L281.621 83.353Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.063 114.9C290.063 116.235 288.98 117.318 287.645 117.318C286.311 117.318 285.229 116.235 285.229 114.9C285.229 113.565 286.311 112.483 287.645 112.483C288.98 112.483 290.063 113.565 290.063 114.9Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.305 114.9C290.305 116.368 289.114 117.559 287.645 117.559C286.177 117.559 284.987 116.368 284.987 114.9C284.987 113.432 286.177 112.241 287.645 112.241C289.114 112.241 290.305 113.432 290.305 114.9Z",
    fill: "#FFB0A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.725 114.9C312.725 116.235 311.642 117.318 310.308 117.318C308.974 117.318 307.891 116.235 307.891 114.9C307.891 113.565 308.974 112.483 310.308 112.483C311.642 112.483 312.725 113.565 312.725 114.9Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.967 114.9C312.967 116.368 311.776 117.559 310.308 117.559C308.84 117.559 307.649 116.368 307.649 114.9C307.649 113.432 308.84 112.241 310.308 112.241C311.776 112.241 312.967 113.432 312.967 114.9Z",
    fill: "#FFB0A5"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.488 55.341H9.49194",
    stroke: "#03458F",
    strokeWidth: 17.264,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.d1392daabe643caa3434a5b00589903d.svg";
export { ForwardRef as ReactComponent };